import { Component, OnInit, Input } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { TranslatedBaseError } from "../TranslatedBaseError";
import { ServiceGroup } from "src/app/models/service-group";
import { ServiceGroupControllerService } from "src/app/services/service-group-controller/service-group-controller.service";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import {SystemProperties} from "../../../models/system-properties";
import {
    SystemPropertiesControllerService,
  } from "../../../services/system-settings/system-properties-controller.service";
import { map } from "rxjs/operators";

@Component({
    selector: "groups",
    templateUrl: "./groups.component.html",
})
export class GroupsComponent extends TranslatedBaseError implements OnInit {

    @Input() public systemProperties: SystemProperties;
    public groups: ServiceGroup[] = [];
    public tempGroup: ServiceGroup = new ServiceGroup();
    public tempName: string = null;

    public isDrawerClosed: boolean = true;

    constructor(
        public serviceGroupControllerService: ServiceGroupControllerService,
        private systemPropertiesControllerService: SystemPropertiesControllerService,
        toastr: ToastrService,
        public translateService: TranslateService) {
            super(toastr, translateService);
    }

    public ngOnInit() {
        console.log("Groups");
        this.getGroups();
    }

    public getGroups() {
        console.log("Get groups");
        this.groups = [];
        this.serviceGroupControllerService.getAllServiceGroups().subscribe(
            (data) => {
                this.groups = data.sort((a, b) => {
                    return a.sortOrder - b.sortOrder;
                });
                const promises = [];
                this.groups.forEach((c, index) => {
                    c.sortOrder = index;
                    promises.push(
                        this.serviceGroupControllerService.getGroupServices(c.id).pipe(map((res) => {
                            return res;
                        })).toPromise(),
                    );
                });
                Promise.all<any[]>(promises).then((results: any[]) => {
                    this.groups.forEach((g, index) => {
                        g.services = results[index];
                    });
                });
            },
            (error) => this.showErrorMessage(error),
        );
    }

    public editGroup(group: ServiceGroup) {
        console.log("create group");
        this.isDrawerClosed = false;
        if (group.id) {
            this.tempGroup = group;
        } else {
            this.tempGroup = new ServiceGroup();
            this.tempGroup.name = this.tempName;
            this.tempGroup.sortOrder = this.groups.length + 1;
        }
    }

    public editSystemProperties() {
        this.systemPropertiesControllerService.updateServiceProperties(this.systemProperties).subscribe(
            (data) => {
                this.responseSuccessful("Group updated");
            },
            (error) => this.showErrorMessage(error),
        );
    }

    public dropped(event: CdkDragDrop<any[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }
        const promises = [];
        this.groups.forEach((c, index) => {
          c.sortOrder = index;
          promises.push(
            this.serviceGroupControllerService.updateGroup(c).pipe(map((data) => {
                return data;
            })).toPromise(),
          );
        });

        Promise.all<any[]>(promises).then((results: any[]) => {
          console.log(results);
          this.responseSuccessful("Categories order updated!");
          this.getGroups();
        });
        console.log(this.groups);
    }

    public removeGroup(group) {
        console.log("remove group", group);
        if (group?.id) {
            this.serviceGroupControllerService.deleteGroup(group.id).subscribe(
                (data) => {
                    this.responseSuccessful("Group deleted");
                    this.getGroups();
                },
                (error) => this.showErrorMessage(error),
            );
        }
    }

    public saveDefaultStatus(group) {
        this.serviceGroupControllerService.updateGroup(group).subscribe(
            (data) => {
                this.responseSuccessful("Group updated");
                this.closeDrawer();
                this.getGroups();
            },
            (error) => this.showErrorMessage(error),
        );
    }

    public saveGroup(e) {
        if (e) {
            if (this.tempGroup.id) {
                this.serviceGroupControllerService.updateGroup(this.tempGroup).subscribe(
                    (data) => {
                        this.responseSuccessful("Group updated");
                        this.closeDrawer();
                        this.getGroups();
                    },
                    (error) => this.showErrorMessage(error),
                );
            } else {
                this.serviceGroupControllerService.createGroup(this.tempGroup).subscribe(
                    (data) => {
                        this.responseSuccessful("Group created");
                        this.closeDrawer();
                        this.getGroups();
                    },
                    (error) => this.showErrorMessage(error),
                );
            }
        }
    }

    public closeDrawer() {
        this.tempName = "";
        this.tempGroup = new ServiceGroup();
        this.isDrawerClosed = true;
    }
}
